module.exports = __webpack_public_path__ + "img/8-en.aa319852.png";